import httpService from "app/services/httpService";
import config from "../../../src/config.json";

const apiUrl = config.apiUrl;

const postLimitBalance = async (value) => {
  try {
    const url = `${apiUrl}/members/limitbalance`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const postSecurityBalance = async (value) => {
  try {
    const url = `${apiUrl}/members/securitybalance`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const getLimitBalance = async (query) => {
  try {
    const data = await httpService.get(
      `${apiUrl}/members/memberlimitbalancelist${query ? `?${query}` : ""}`
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getSecurityBalance = async (query) => {
  try {
    const data = await httpService.get(
      `${apiUrl}/members/membersecuritybalancelist${query ? `?${query}` : ""}`
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

const exportLimitBalance = async (queryString) => {
  try {
    const url = `${apiUrl}/members/limit-balance-list/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

const exportSecurityBalance = async (queryString) => {
  try {
    const url = `${apiUrl}/members/security-balance-list/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

export {
  postLimitBalance,
  postSecurityBalance,
  getLimitBalance,
  getSecurityBalance,
  exportLimitBalance,
  exportSecurityBalance,
};
